module.exports = __webpack_public_path__ + "img/NextStep.0ca6700a.svg";